module.exports = __webpack_public_path__ + "img/asxBig.833ba38b.jpg";